import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ShareLinkIcon from '../../static/icons/black-share-icon.svg';

const CopyComponent = ({
  textToCopy,
  timeout = 2000,
  copiedText = 'Copied!',
  copyText = 'Copy',
  icon = null,
  className = '',
  onCopy = () => {},
  showInput = false,
  activeBorder = false,
  inputClassName = '',
  inputProps = {},
  ...rest
}) => {
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => {
        setIsCopied(false);
      }, timeout);
      return () => clearTimeout(timer);
    }
  }, [isCopied, timeout]);

  const handleCopySuccess = () => {
    setIsCopied(true);
    onCopy();
  };

  const copyButton = (
    <CopyButton className={className} data-testid="copy-button" {...rest}>
      {icon && (
        <span className="icon-wrapper" style={{ marginRight: '8px' }}>
          {icon}
        </span>
      )}
      {isCopied ? copiedText : copyText}
    </CopyButton>
  );

  if (!showInput) {
    return (
      <CopyToClipboard text={textToCopy} onCopy={handleCopySuccess}>
        {copyButton}
      </CopyToClipboard>
    );
  }

  return (
    <Container>
      <InputWrapper>
        <IconImg src={ShareLinkIcon} alt="copy icon" />
        <Input
          type="text"
          value={textToCopy}
          readOnly
          $activeBorder={activeBorder}
          className={inputClassName}
          data-testid="copy-input-field"
          {...inputProps}
        />
      </InputWrapper>

      <CopyToClipboard text={textToCopy} onCopy={handleCopySuccess}>
        {copyButton}
      </CopyToClipboard>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
`;

const InputWrapper = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
`;

const IconImg = styled.img`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 16px;
  pointer-events: none;
`;

const Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 12px 12px 12px 36px;
  border: 1.5px solid
    ${({ $activeBorder }) =>
      $activeBorder ? '#7200e0' : 'rgba(201, 198, 204, 0.85)'};
  background: #fff;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
  color: #1e252a;

  &:focus {
    outline: none;
  }
`;

const CopyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-height: 44px;
  cursor: pointer;
  background-color: #7200e0;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
`;

export default CopyComponent;
